/**
 * 解析 Worker（U154 / I99）。走査窓のコード列だけ受け取り、メインスレッドを止めない。
 */

import { runAnalysisOnCodes, type AnalysisRequest, type AnalysisResult } from '@kensuke/genome-core';

export interface GeneAnalysisAnalyzeRequest {
  type: 'ANALYZE';
  request: AnalysisRequest;
  codes: Uint8Array;
}

export interface GeneAnalysisAnalyzeDone {
  type: 'DONE';
  result: AnalysisResult;
  elapsedMs: number;
}

export interface GeneAnalysisAnalyzeError {
  type: 'ERROR';
  message: string;
}

export type GeneAnalysisAnalyzeResponse = GeneAnalysisAnalyzeDone | GeneAnalysisAnalyzeError;

export function runGeneAnalysisAnalyze(
  message: GeneAnalysisAnalyzeRequest
): GeneAnalysisAnalyzeDone {
  const startedAt = Date.now();
  const result = runAnalysisOnCodes(message.codes, message.request);
  return { type: 'DONE', result, elapsedMs: Date.now() - startedAt };
}

function isDedicatedWorkerScope(value: unknown): value is DedicatedWorkerGlobalScope {
  return typeof DedicatedWorkerGlobalScope !== 'undefined' && value instanceof DedicatedWorkerGlobalScope;
}

if (isDedicatedWorkerScope(self)) {
  self.onmessage = (event: MessageEvent<GeneAnalysisAnalyzeRequest>) => {
    if (event.data?.type !== 'ANALYZE') return;
    try {
      self.postMessage(runGeneAnalysisAnalyze(event.data));
    } catch (error) {
      const message: GeneAnalysisAnalyzeError = {
        type: 'ERROR',
        message: error instanceof Error ? error.message : String(error),
      };
      self.postMessage(message);
    }
  };
}
